import { connect } from 'react-redux';

import {
  selectIsError,
  selectYear,
  selectMOTD,
  selectEmailSignature,
  selectYaspFormLink,
} from 'selectors/systemSettingsSelectors';
import { selectEventDates } from 'selectors/eventDatesSelectors';
import { selectIsAdmin, selectIsLoggedIn } from 'selectors/authenticationSelectors';
import {
  getYear,
  updateYear,
  getEventAdmin,
  updateEventAdmin,
} from 'actions/thunks/systemSettings';
import { getEventDates } from 'actions/thunks/eventDates';
import EventManagementPage from 'components/pages/admin/EventManagementPage';

const mapStateToProps = (state) => ({
  isError: selectIsError(state),
  year: selectYear(state),
  eventDates: selectEventDates(state),
  motd: selectMOTD(state),
  emailSignature: selectEmailSignature(state),
  yaspFormLink: selectYaspFormLink(state),
  isAdmin: selectIsAdmin(state),
  isLoggedIn: selectIsLoggedIn(state),
});

const mapDispatchToProps = (dispatch) => ({
  getYear: () => dispatch(getYear()),
  updateYear: (newYear) => dispatch(updateYear(newYear)),
  getEventDates: () => dispatch(getEventDates()),
  getEventAdmin: (eventDateId) => dispatch(getEventAdmin(eventDateId)),
  updateEventAdmin: (eventDateId, eventAdmin) => dispatch(updateEventAdmin(eventDateId, eventAdmin)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EventManagementPage);
